/* eslint-disable no-restricted-syntax */
import Cookies from 'js-cookie';
import axios from '@shared/config/baseAPI';

const deviceId = Cookies.get('deviceId'); // change this with your device id

export const generateQrCode = async () => {
  try {
    return await axios.get('/site/generate-qr-code');
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkQrSignIn = async (accessKey) => {
  try {
    return await axios.get(`/site/check-qr-sign-in?accesskey=${accessKey}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const userLoggedIn = async (token) => {
  try {
    return await axios.post('/user/profile', null, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${token}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const userLogout = async (token) => {
  try {
    return await axios.post('/site/login-out', null, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${token}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const sendVerifySMS = async (username) => {
  try {
    const data = new URLSearchParams({
      username,
    });
    return await axios.post('/user/oauth-send-verify-sms', data, { headers: { 'device-id': `${deviceId}`, 'Device-Type': 'web', 'Version-Code': 999999 } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const ssoLogin = async (data) => {
  try {
    return await axios.post('/user/oauth-token', data, { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const socialMediaLogin = async (data) => {
  try {
    return await axios.post('/user/oauth-login', data, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'device-id': `${deviceId}`,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGiftList = async (data) => {
  const token = Cookies.get('token'); // token from cookie
  try {
    return await axios.post('/live/gift-list', data, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${token}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const giftPresent = async (data) => {
  const token = Cookies.get('token'); // token from cookie
  try {
    return await axios.post('/live/present', data, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${token}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
